module.exports = __webpack_public_path__ + "img/HP NECKLACE BW.fe47f86.svg";